export const validateLatitude = (input: string): boolean => {
  const latRegex = /^-?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;

  return latRegex.test(input);
};
